<template>
    <div class="sntopbar">
        <div class="row">
            <div class="col-md-2"><img style="height: 75px;" src="img/bucher.jpg" /></div>
            <div class="col-md-6"></div>
            <div class="col-md-4"><messaggio-globale fontawesome="standard"></messaggio-globale></div>
        </div>
    </div>
    
</template>

<script>
import MessaggioGlobale from "@/components/MessaggioGlobale.vue";

export default {
    name: "TopbarElement",
    components: { MessaggioGlobale }
}
</script>

<style scoped>
    .sntopbar {
        overflow: hidden;
        background-color: #CC3731;
        position: fixed;
        top: 0;
        width: 100%;
        height: 80px;
        color: #fff;
        text-align: left;
        padding: 2px 2px 2px 20px;
        z-index:100;
    }

   
</style>
